import React, { useEffect, useState } from 'react';

import { customTheme } from "./Theme";
import { Grommet } from "grommet";
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import Section from './Section';
import PersonalInfo from './PersonalInfo';

const App = () => {
    const [theme, setTheme] = useState();


    useEffect(() => {
        const storageTheme = localStorage.getItem('theme');
        setTheme(storageTheme ? storageTheme : 'light');
        localStorage.setItem('theme', storageTheme ? storageTheme : 'light');
    }, []);

    useEffect(() => {
        if(theme) {
            setTheme(theme);
            localStorage.setItem('theme', theme);
        }
    }, [theme]);


    return (
        <Grommet theme={customTheme} themeMode={theme} full>
            <Header changeTheme={setTheme} theme={theme} />
            <Section>
            <PersonalInfo />
            </Section>
            <Footer />
        </Grommet>
    )
}

export default App;